import React from "react";
import "./styles/DineInBrandHeader.css";

interface DineInBrandHeaderProps {
  businessName: string;
  tableNumber: string;
  /** true while phase is "revealCode" — session was just created and is live. */
  live: boolean;
}

const DineInBrandHeader: React.FC<DineInBrandHeaderProps> = ({
  businessName,
  tableNumber,
  live,
}) => {
  return (
    <div className="dine-in-brand-header">
      <span className="dine-in-brand-header__name">{businessName}</span>
      {live ? (
        <span className="dine-in-brand-header__live">
          <span className="dine-in-brand-header__pip" />
          Session live
        </span>
      ) : (
        <span className="dine-in-brand-header__table-chip">Table {tableNumber}</span>
      )}
    </div>
  );
};

export default DineInBrandHeader;
